 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"index": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"index": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({}[chunkId]||chunkId) + "." + {"chunk-17bbd880":"cbe6c539","chunk-1febc2da":"9b004116","chunk-21fc9d92":"3b0d4b9e","chunk-2d22c341":"e08fccfb","chunk-32e861f6":"6e7f64cc","chunk-32fa970a":"bcaad238","chunk-4057bdef":"2b9978de","chunk-44cdc844":"dd219c81","chunk-4860f0a7":"91bd4d9d","chunk-2d20edd4":"433f9889","chunk-56c7260c":"432eb43b","chunk-0e3dce9d":"045c3ab8","chunk-11a3ff11":"75bc303c","chunk-0a830f72":"cc4f5bbb","chunk-0b8a6c92":"7711dc85","chunk-2bc02faf":"6491a967","chunk-35b338fc":"8f323549","chunk-4584d758":"3533cd62","chunk-5d0aec74":"3aacbc6f","chunk-66ba65c2":"b9bd561c","chunk-6823dc66":"50c7bc34","chunk-71de06b3":"7e1a75e3","chunk-c1218990":"7c9f2772","chunk-34ac8b42":"3e991453","chunk-6166d97e":"9e5669d2","chunk-2a2e91da":"f6b8b664","chunk-787ee1b8":"336663e8","chunk-4194638c":"4d4fb612","chunk-f59dd0a8":"820f9bc0","chunk-338520fe":"c2802972","chunk-469f90b6":"d745083a","chunk-59c47205":"f20ab096","chunk-5b6cc122":"cffebc73","chunk-5bc1cf96":"ae93d88d","chunk-26955926":"0eac59a1","chunk-d07d2e6c":"b18625bb","chunk-64bc42f3":"9bd00440","chunk-7a1395ca":"2ef4ee6e","chunk-8d9f4e74":"d2617dfa","chunk-d81aaf22":"43734601","chunk-da8de2c2":"eaaf0378","chunk-2d0aacc0":"3e63e280","chunk-2d0ab514":"3d7dc7d9","chunk-2d0b1e5f":"d976fd9c","chunk-2d0b21c6":"4e6ae6fe","chunk-2d0b326e":"3c897938","chunk-2d0b34b9":"9f60b875","chunk-2d0ba549":"fbcb8197","chunk-2d0bceb4":"86225f3b","chunk-2d0bddf4":"b37cfa94","chunk-2d0bdf49":"1bfa2d37","chunk-2d0c0ebf":"c2c4caa3","chunk-2d0c1979":"b56c8208","chunk-2d0c1b75":"eb0791b2","chunk-2d0cf715":"2a0ffac6","chunk-2d0d691f":"3622db64","chunk-2d0d836a":"a88d5206","chunk-2d0da410":"5bf2576f","chunk-2d0e1743":"bce8c6e2","chunk-2d0e19ee":"6a99a89b","chunk-2d0e1c30":"1986845a","chunk-2d0e8e41":"1c16159b","chunk-2d0e9358":"4ff80b67","chunk-2d0f0fd0":"ba271d19","chunk-2d0f11af":"18b9a54c","chunk-2d2091bd":"24ee5877","chunk-2d209206":"e8a3d10c","chunk-2d20e860":"c6c74cc1","chunk-2d20f169":"c7b2c23e","chunk-2d20f186":"82fd5842","chunk-2d21009e":"2b666fbe","chunk-2d212bf1":"207b6c00","chunk-2d21329e":"e2fcf9ec","chunk-2d216f68":"bda1e654","chunk-2d21a426":"617c227c","chunk-2d21d4e1":"d3f4d266","chunk-2d21e3f7":"31028a14","chunk-2d224d24":"1ea10652","chunk-2d22d9a8":"40456843","chunk-2d22d9ba":"c0147c6b","chunk-2d22db83":"357ce57f","chunk-774b734f":"8eb8246d","chunk-4a45ee33":"af27fde1"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-32e861f6":1,"chunk-4057bdef":1,"chunk-4860f0a7":1,"chunk-56c7260c":1,"chunk-0e3dce9d":1,"chunk-11a3ff11":1,"chunk-0a830f72":1,"chunk-0b8a6c92":1,"chunk-2bc02faf":1,"chunk-35b338fc":1,"chunk-4584d758":1,"chunk-5d0aec74":1,"chunk-66ba65c2":1,"chunk-6823dc66":1,"chunk-71de06b3":1,"chunk-c1218990":1,"chunk-34ac8b42":1,"chunk-2a2e91da":1,"chunk-787ee1b8":1,"chunk-4194638c":1,"chunk-f59dd0a8":1,"chunk-338520fe":1,"chunk-469f90b6":1,"chunk-5b6cc122":1,"chunk-5bc1cf96":1,"chunk-26955926":1,"chunk-d07d2e6c":1,"chunk-64bc42f3":1,"chunk-8d9f4e74":1,"chunk-da8de2c2":1,"chunk-4a45ee33":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({}[chunkId]||chunkId) + "." + {"chunk-17bbd880":"31d6cfe0","chunk-1febc2da":"31d6cfe0","chunk-21fc9d92":"31d6cfe0","chunk-2d22c341":"31d6cfe0","chunk-32e861f6":"cea75bec","chunk-32fa970a":"31d6cfe0","chunk-4057bdef":"a80d1ed7","chunk-44cdc844":"31d6cfe0","chunk-4860f0a7":"60cdf4da","chunk-2d20edd4":"31d6cfe0","chunk-56c7260c":"69531e34","chunk-0e3dce9d":"5689b01b","chunk-11a3ff11":"f74502eb","chunk-0a830f72":"f44a8936","chunk-0b8a6c92":"e617ed34","chunk-2bc02faf":"9e464530","chunk-35b338fc":"89d76595","chunk-4584d758":"fcc98551","chunk-5d0aec74":"fcc98551","chunk-66ba65c2":"36f96941","chunk-6823dc66":"35e24eb0","chunk-71de06b3":"aa2e2dad","chunk-c1218990":"5cd6a74a","chunk-34ac8b42":"f44a8936","chunk-6166d97e":"31d6cfe0","chunk-2a2e91da":"d819b3a4","chunk-787ee1b8":"f44a8936","chunk-4194638c":"54034378","chunk-f59dd0a8":"7855ffa6","chunk-338520fe":"28a6f204","chunk-469f90b6":"2ce799ad","chunk-59c47205":"31d6cfe0","chunk-5b6cc122":"b3bf1326","chunk-5bc1cf96":"fc4d3602","chunk-26955926":"0312ef7a","chunk-d07d2e6c":"6e1456a1","chunk-64bc42f3":"b7039a38","chunk-7a1395ca":"31d6cfe0","chunk-8d9f4e74":"f44a8936","chunk-d81aaf22":"31d6cfe0","chunk-da8de2c2":"a80d1ed7","chunk-2d0aacc0":"31d6cfe0","chunk-2d0ab514":"31d6cfe0","chunk-2d0b1e5f":"31d6cfe0","chunk-2d0b21c6":"31d6cfe0","chunk-2d0b326e":"31d6cfe0","chunk-2d0b34b9":"31d6cfe0","chunk-2d0ba549":"31d6cfe0","chunk-2d0bceb4":"31d6cfe0","chunk-2d0bddf4":"31d6cfe0","chunk-2d0bdf49":"31d6cfe0","chunk-2d0c0ebf":"31d6cfe0","chunk-2d0c1979":"31d6cfe0","chunk-2d0c1b75":"31d6cfe0","chunk-2d0cf715":"31d6cfe0","chunk-2d0d691f":"31d6cfe0","chunk-2d0d836a":"31d6cfe0","chunk-2d0da410":"31d6cfe0","chunk-2d0e1743":"31d6cfe0","chunk-2d0e19ee":"31d6cfe0","chunk-2d0e1c30":"31d6cfe0","chunk-2d0e8e41":"31d6cfe0","chunk-2d0e9358":"31d6cfe0","chunk-2d0f0fd0":"31d6cfe0","chunk-2d0f11af":"31d6cfe0","chunk-2d2091bd":"31d6cfe0","chunk-2d209206":"31d6cfe0","chunk-2d20e860":"31d6cfe0","chunk-2d20f169":"31d6cfe0","chunk-2d20f186":"31d6cfe0","chunk-2d21009e":"31d6cfe0","chunk-2d212bf1":"31d6cfe0","chunk-2d21329e":"31d6cfe0","chunk-2d216f68":"31d6cfe0","chunk-2d21a426":"31d6cfe0","chunk-2d21d4e1":"31d6cfe0","chunk-2d21e3f7":"31d6cfe0","chunk-2d224d24":"31d6cfe0","chunk-2d22d9a8":"31d6cfe0","chunk-2d22d9ba":"31d6cfe0","chunk-2d22db83":"31d6cfe0","chunk-774b734f":"31d6cfe0","chunk-4a45ee33":"bdc62693"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/themes/cm-sgd-22/partials/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
